import React from 'react';
import { ShoppingCart, Hammer, Sofa, Shirt, Smartphone, Tv, Sparkles, Gem, Dumbbell, Flower2, Baby, PawPrint, UtensilsCrossed, Car, Snowflake, BadgePercent, Tag, LayoutGrid } from 'lucide-react';
import { t } from '../lib/i18n';

const ICONS = { ShoppingCart, Hammer, Sofa, Shirt, Smartphone, Tv, Sparkles, Gem, Dumbbell, Flower2, Baby, PawPrint, UtensilsCrossed, Car, Snowflake, BadgePercent };

export const CategoryIcon = ({ name, size = 20, className = '' }) => {
  const Icon = ICONS[name] || Tag;
  return <Icon size={size} className={className} />;
};

// Desktop mega-menu grid of category tiles.
const CategoryGrid = ({ categories, activeCategory, counts, onSelect, cols = 4 }) => (
  <div className={`max-w-[1200px] mx-auto ${cols === 4 ? 'px-4 py-5' : 'px-2 py-3'}`} data-testid="categories-grid">
    <div className="flex items-center justify-between mb-4">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#808080]">{t('Parcourir par catégorie')}</p>
      {activeCategory && (
        <button onClick={() => onSelect(null)} data-testid="category-all"
          className="inline-flex items-center gap-1.5 text-xs font-bold text-[#E50914] hover:underline">
          <LayoutGrid size={13} /> {t('Toutes les catégories')}
        </button>
      )}
    </div>
    <div className={`grid gap-2.5 ${cols === 2 ? "grid-cols-2" : "grid-cols-4"}`}>
      {categories.map((cat, i) => {
        const active = activeCategory === cat.slug;
        const count = counts?.[cat.slug];
        return (
          <button key={cat.id} onClick={() => onSelect(cat.slug)} data-testid={`category-${cat.slug}`} aria-pressed={active}
            style={{ animationDelay: `${i * 20}ms` }}
            className={`group flex items-center gap-3 p-2.5 pe-3 rounded-xl border text-left transition-all duration-200 fade-in hover:-translate-y-0.5 ${
              active ? 'bg-[#E50914] border-[#E50914] text-white shadow-[0_8px_24px_rgba(229,9,20,0.35)]' : 'bg-[#141414] border-[#262626] text-white hover:border-[#E50914]/60 hover:shadow-lg'}`}>
            <span className={`shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${active ? 'bg-white/20' : 'bg-[#E50914]/10 text-[#E50914] group-hover:bg-[#E50914] group-hover:text-white'}`}>
              <CategoryIcon name={cat.icon} size={20} />
            </span>
            <span className="min-w-0 flex-1">
              <span className={`block text-sm font-bold leading-tight ${cols === 2 ? "line-clamp-2" : "truncate"}`}>{t(cat.name)}</span>
              {count != null && <span className={`block text-[11px] mt-0.5 ${active ? 'text-white/80' : 'text-[#808080]'}`}>{count} {t(count === 1 ? 'catalogue' : 'catalogues')}</span>}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);

export default CategoryGrid;
